export default __webpack_public_path__ + "static/media/cooking_2020_OV_seemore_NN-CS89LB_Asia_04_201023-nz.a9b98623.jpg";